module.exports = __webpack_public_path__ + "img/55.fb566e07.jpg";